import React, { useState, useEffect, useContext } from "react";
import { plantCurveApi } from "../../../../../api/Api";
import { jsPDF } from "jspdf";
import "jspdf-autotable"; // Ensure you import the autoTable plugin
import * as XLSX from "xlsx";
import logo from '../../../../../assets/img/logos/logo 2.png';
import EnergyChartPower from "../../../../../components/charts/energy_reporting/EnergyChartPower";
import PlantEnergy from "../../dashboard/dashboardTabs/tab4Content/plantEnergy/PlantEnergy";
import { Box, Card, CardActions, CardHeader, Container, CssBaseline, Grid, IconButton, Paper, Stack, Typography, colors, useTheme,Button } from '@mui/material';
import AppModal from "../../../../../components/AppModal";
import InvverterFullSize from "../../../../../components/inverter/InvverterFullSize";
import { AppThemeContext } from "../../../../../context/AppThemeContext";
import PlantKusumDataLog from "./PlantKusumDatalog";


// Utility function to format date as 'YYYY-MM-DD HH:mm'
const formatDateTime = (date) => {
    const pad = (num) => String(num).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};


export default function PlantKusumLog() {
    const { PrimaryColor } = useContext(AppThemeContext);


    const now = new Date(); // Current date and time

    // Set the startDate to 5:00 AM of the current date
    const initialStartDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 5, 0);

    // Set the endDate to 8:00 PM (20:00) of the current date
    const initialEndDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 20, 0);

    const [startDate, setStartDate] = useState(formatDateTime(initialStartDate)); // Set default start date
    const [endDate, setEndDate] = useState(formatDateTime(initialEndDate)); // Set default end date

    const [logData, setLogData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { spacing, palette, shape: { borderRadius } } = useTheme();

    const [OpenMix, setOpenMix] = useState(false);
    const handleOpenMix = () => setOpenMix(true);
    const handleCloseMix = () => setOpenMix(false);

    return (
        <>


            {/* <div className="my-2">
                <PlantEnergy />
            </div> */}

            <Grid container style={{ padding: "0", margin: "0" }}>


                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ overflow: 'hidden' }}>

                    <Stack rowGap={spacing(0)} sx={{ marginTop: '.4rem', overflow: 'hidden' }}>
                        {/* First Card */}
                        <Stack
                            component={Card}
                            p={spacing(1)}
                            sx={{ height: 'auto', overflow: 'hidden', marginBottom: spacing(2) }}
                        >

                            <div>

                                {loading && <p>Loading chart data...</p>}
                                {error && <p style={{ color: "red" }}>{error}</p>}
                                {!loading && !error && (
                                    <>
                                        <InvverterFullSize title={``} onFullScreen={handleOpenMix} />
                                        <PlantKusumDataLog/>
                                        <AppModal open={OpenMix} handleClose={handleCloseMix}>
                                        <PlantKusumDataLog/>
                                        </AppModal>
                                    </>
                                )}
                            </div>
                        </Stack>


                    </Stack>


                </Grid>

            </Grid>

        </>
    );
}

